import React, { useState, useEffect, useRef, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";
import PulseLoader from "../Utility/PulseLoader";
import CustomHeader from "../Utility/CustomHeader";

ModuleRegistry.registerModules([AllCommunityModule]);

function PurchasePaymentTable({ loading }) {
  const staticData = [
    {
      PAYMENT: "PYM001",
      PAIDON: "05-Nov-25",
      SETTLED: "YES",
      PAIDAMT: "5,000",
      PAIDVIA: "Bank",
      PAYMENTMODE: "IMPS",
      TXNUTRREFNO: "UTR12345678"
    },
    {
      PAYMENT: "PYM002",
      PAIDON: "04-Nov-25",
      SETTLED: "NO",
      PAIDAMT: "1,800",
      PAIDVIA: "UPI",
      PAYMENTMODE: "Google Pay",
      TXNUTRREFNO: "UTR98765432"
    }
  ];

  const [rowData, setRowData] = useState(staticData);
  const gridRef = useRef(null);

  const tableStyle = `
    .ag-horizontal-right-spacer.ag-scroller-corner { display: none !important; }
    .ag-header-viewport { overflow-x: hidden !important; will-change: auto !important; }
    .ag-theme-quartz .ag-row-selected::before {
      content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 4px;
      background-color: #77c658; border-top-left-radius: 4px; border-bottom-left-radius: 4px; z-index: 1;
    }
    .ag-cell-value { border-left: unset !important; border-right: 1px solid #e5e5e5 !important; }
    .ag-theme-quartz .ag-row-selected::after { /* Hidden for cleaner look */ }
    .ag-theme-quartz .ag-row-hover .ag-row-selected:hover { background-color: #f4fbf1 !important; }
    .ag-checkbox-input-wrapper::before, .ag-checkbox-input-wrapper::after { display: none; }
    .ag-ltr .ag-sort-indicator-icon { display: none; }
    .ag-header, .ag-advanced-filter-header {
      background-color: #f9f9f9; border-bottom: 1px solid #ebebeb;
      font-family: 'Nunito', Arial, sans-serif;
    }
    .ag-header-cell-text {
      font-size: 0.9rem; text-transform: uppercase; color: #1e374f;
      font-weight: 600; font-family: 'Nunito', sans-serif !important;
    }
    .ag-header-cell-resize::after { background-color: #1991eb52; }
    .ag-ltr .ag-cell { text-align: center; display: flex; align-items: center; }
    .ag-header { border: none; padding: 0.5rem 0; min-height: 44px !important; }
    .ag-row { border: 1px solid #eeedf0; }
    .ag-row-odd { background-color: #fff !important; }
    .ag-row-even { background-color: #f7f7f7 !important; }
    .ag-root-wrapper { border: unset; background: transparent }
    .ag-body-viewport { border-top-left-radius: 5px !important; border-top-right-radius: 5px !important; }
    .ag-theme-quartz .ag-header-cell-filter-button { display: none; }
    .ag-header-cell-resize:after {
      background-color: #1991eb52; content: ""; display: block; height: 30%;
      position: absolute; top: calc(50% - 30% * .5); z-index: 1;
    }
    .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus {
      font-size: .9rem;
    }
    .ag-body-vertical-scroll { display : none; }
    .ag-header-cell-sortable .ag-header-cell-label { justify-content: start; }
    .ag-ltr .ag-cell {
      font-weight: 500 !important; letter-spacing: 0.5px; color: #2b2b2b !important;
    }
    .ag-header-cell-label { display: flex; justify-content: center; }
    .ag-cell:focus, .ag-cell-focus, .ag-row-focus {
      outline: none !important; border: none !important; box-shadow: none !important;
    }
  `;

  useEffect(() => {
    if (!gridRef.current || !gridRef.current.api) return;
    const api = gridRef.current.api;
    if (loading) {
      api.showLoadingOverlay();
    } else if (!loading && rowData.length === 0) {
      api.showNoRowsOverlay();
    } else {
      api.hideOverlay();
    }
  }, [loading, rowData]);

  // Column Definitions as per the image
  const [colDefs] = useState([
    { headerName: "PAYMENT", field: "PAYMENT", minWidth: 110, sortable: true, filter: true, cellRenderer: params => <span className="text-secondary fw-medium small">{params.value}</span> },
    { headerName: "PAID ON", field: "PAIDON", minWidth: 110, sortable: true, filter: true, cellRenderer: params => <span className="text-secondary fw-medium small">{params.value}</span> },
    // { headerName: "SETTLED", field: "SETTLED", minWidth: 90, sortable: true, filter: true },
    { headerName: "PAID AMT", field: "PAIDAMT", minWidth: 110, sortable: true, filter: true, cellRenderer: params => <span className="text-secondary fw-medium small">{params.value}</span> },
    { headerName: "PAID VIA", field: "PAIDVIA", minWidth: 110, sortable: true, filter: true,cellRenderer: params => <span className="text-secondary fw-medium small">{params.value}</span>},
    { headerName: "PAYMENT MODE", field: "PAYMENTMODE", minWidth: 110, sortable: true, filter: true,cellRenderer: params => <span className="text-secondary fw-medium small">{params.value}</span> },
    // { headerName: "TXN UTR REF NO", field: "TXNUTRREFNO", minWidth: 120, sortable: true, filter: true }
  ]);

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      filter: true,
      sortable: true,
      enableRowGroup: true,
      sort: "asc",
      resizable: true,
      headerComponent: CustomHeader,
      headerClass: "ag-header-cell-text"
    }),
    []
  );

  const CustomLoadingOverlay = () => (
    <div className="flex flex-col items-center justify-center h-full">
      <PulseLoader />
    </div>
  );

  const CustomNoRowsOverlay = () => (
    <div className="flex flex-col items-center justify-center h-full">
      <img
        src="/Images/doctortable.png"
        alt="No data available"
        className="w-64 h-64 object-contain mb-6"
      />
      <p className="text-gray-600 text-lg font-semibold">
        No Payment Info Available
      </p>
    </div>
  );

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        id="grid-wrapper"
        className="ag-theme-quartz custom-ag-grid"
        style={{
          width: "100%",
          height: "454px",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          borderRadius: "12px",
          backgroundColor: "#fff",
          minHeight: "32rem",
        }}
      >
        <style>{tableStyle}</style>
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          rowClass="tbl-row-sc"
          ref={gridRef}
          loadingOverlayComponent={CustomLoadingOverlay}
          noRowsOverlayComponent={CustomNoRowsOverlay}
          rowHeight={40}
          headerHeight={30}
        />
      </div>
    </div>
  );
}

export default PurchasePaymentTable;
